/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { MoneytreeStatusActions } from './moneytree-status-actions';

/**
 * 
 * @export
 * @interface MoneytreeStatus
 */
export interface MoneytreeStatus {
    /**
     * Moneytree connection status
     * @type {string}
     * @memberof MoneytreeStatus
     */
    'status': MoneytreeStatusStatusEnum;
    /**
     * 
     * @type {MoneytreeStatusActions}
     * @memberof MoneytreeStatus
     */
    'actions': MoneytreeStatusActions;
}

export const MoneytreeStatusStatusEnum = {
    unknown: 'UNKNOWN',
    notConnected: 'NOT_CONNECTED',
    notRegistered: 'NOT_REGISTERED',
    needRelink: 'NEED_RELINK',
    fullyLinked: 'FULLY_LINKED'
} as const;

export type MoneytreeStatusStatusEnum = typeof MoneytreeStatusStatusEnum[keyof typeof MoneytreeStatusStatusEnum];


